import React from "react";
import Table from "react-bootstrap/Table";

const StudentTable = ({ students }) => {
  // Add comprehensive null/undefined checks
  if (!students) {
    return (
      <div className="alert alert-warning text-center m-3">
        <p>No students data provided</p>
      </div>
    );
  }

  if (!Array.isArray(students)) {
    return (
      <div className="alert alert-danger text-center m-3">
        <p>Invalid students data format</p>
      </div>
    );
  }

  if (students.length === 0) {
    return (
      <div className="alert alert-info text-center m-3">
        <p>No students enrolled yet</p>
      </div>
    );
  }

  return (
    <div className="table-responsive">
      <Table striped bordered hover>
        <thead>
          <tr className="text-light" style={{ backgroundColor: "#B8529E" }}>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Date Enrolled</th>
            <th>Progress</th>
          </tr>
        </thead>
        <tbody>
          {students
            .filter(student => student != null) // Filter out null students
            .map((student, index) => {
              // Safe property access with fallbacks
              const user = student?.user || {};
              const firstName = user?.first_name || 'N/A';
              const lastName = user?.last_name || 'N/A';
              const dateEnrolled = student?.date_enrolled ? new Date(student.date_enrolled).toLocaleDateString() : 'N/A';
              const progress = student?.progress != null ? `${student.progress}%` : '0%';

              return (
                <tr key={student?.id || `student-${index}`}>
                  <td>{firstName}</td>
                  <td>{lastName}</td>
                  <td>{dateEnrolled}</td>
                  <td>{progress}</td>
                </tr>
              );
            })
          }
        </tbody>
      </Table>
    </div>
  );
};

export default StudentTable;